import { render, staticRenderFns } from "./video-swiper.vue?vue&type=template&id=0feb57db&scoped=true&"
import script from "./video-swiper.vue?vue&type=script&lang=js&"
export * from "./video-swiper.vue?vue&type=script&lang=js&"
import style0 from "./video-swiper.vue?vue&type=style&index=0&id=0feb57db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feb57db",
  null
  
)

export default component.exports